/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2020, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { schema } from 'normalizr';
const INTEGRATIONS_VARIABLES = [
  'locale',
  'timezone',
  'channel_name',
  'last_seen_at'
];

// --- user variables --
export const variableSchema = new schema.Entity(
  'variables',
  {},
  {
    idAttribute: 'variable', // referring to variableId
    processStrategy: variable => ({ ...variable, id: variable.variable })
  } //add an 'id' prop so that the datatable can correctly just list these
);

export const variablesSchema = new schema.Array(variableSchema);

// -- system variables --
export const systemVariableSchema = new schema.Entity(
  'variables_system',
  {},
  {
    idAttribute: 'system_variable',
    processStrategy: system_variable => ({
      ...system_variable,
      id: system_variable.system_variable,
      integrationVariable: INTEGRATIONS_VARIABLES.includes(
        system_variable.system_variable
      )
    })
  }
);

export const systemVariablesSchema = new schema.Array(systemVariableSchema);
